export interface SettlementSpriteHitBounds {
  /** Untrimmed source-image coordinates, before any screen/camera transform. */
  x: number;
  y: number;
  width: number;
  height: number;
  /** Exclusive visible bottom in source pixels; omitted means the full source height. */
  cropBottom?: number;
}

export type SettlementSpriteAlphaSampler = (x: number, y: number) => number | null | undefined;

/** Match the existing alpha threshold, but never sample pixels hidden by source bounds or crop. */
export function isSettlementSpriteHit(
  bounds: SettlementSpriteHitBounds,
  sampleAlpha: SettlementSpriteAlphaSampler,
): boolean {
  const { x, y, width, height, cropBottom = height } = bounds;
  if (
    ![x, y, width, height, cropBottom].every(Number.isFinite) ||
    width <= 0 ||
    height <= 0 ||
    cropBottom <= 0 ||
    x < 0 ||
    y < 0 ||
    x >= width ||
    y >= Math.min(height, cropBottom)
  )
    return false;

  const alpha = sampleAlpha(x, y);
  return typeof alpha === 'number' && Number.isFinite(alpha) && alpha >= 24 && alpha <= 255;
}
